import { toast } from "react-toastify";

export default function handlingError(err) {
  /**
  |--------------------------------------------------
  | EDITED ON 26-maret-2019 | PLEASE DONT REMOVE THIS COMMENT INFORMATION !!!!!
  |
  | you can use this method for handling error from server. 
  | in method onRegisterFailed(error) and onUpdateFailed(error) or etc.
  |
  | E.G :
  | # onRegisterFailed(error) { handlingError(error.response.data) } OR
  | # onRegisterFailed(error) { handlingError(error) }
  | 
  | BUT FOR BEST PRACTICE PLEASE USE handlingError(error)
  |
  |--------------------------------------------------
  */

  try {
    let data_error_detail = null;

    if (err) {
      if (err.hasOwnProperty("response")) {
        if (err.response.hasOwnProperty("data")) {
          /**
          |--------------------------------------------------
          | if you use handlingError(error) he will go here
          |--------------------------------------------------
          */
          data_error_detail = err.response.data;
        }
      } else {
        /**
        |--------------------------------------------------
        | if you use handlingError(error.response.data) he will go here
        |--------------------------------------------------
        */
        data_error_detail = err;
      }
    }

    if (data_error_detail) {
      for (let key in data_error_detail) {
        toast.error("Error : " + data_error_detail[key]);
      }
    } else {
      toast.error(
        "We are sorry. This error may not be your fault. but the server incorrectly provided detailed error information."
      );
    }
  } catch (error) {
    toast.error("Sorry something went wrong.");
  }
}



// WEBPACK FOOTER //
// ./src/App/utils/handlingError.js